import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "px-4 sm:px-6 lg:px-8 flow-root h-[calc(100vh-360px)] overflow-auto" }
const _hoisted_2 = {
  key: 0,
  class: "-mx-4 -my-2 sm:-mx-6 lg:-mx-8"
}
const _hoisted_3 = { class: "inline-block min-w-full py-2 align-middle" }
const _hoisted_4 = { class: "min-w-full border-separate border-spacing-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "sticky top-0 z-10 border-b border-gray-300 bg-white/75 py-3.5 pr-3 pl-4 text-left text-sm font-semibold text-dark backdrop-blur-sm backdrop-filter sm:pl-6 lg:pl-8"
    }, "Start Date"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "sticky top-0 z-10 hidden border-b border-gray-300 bg-white/75 px-3 py-3.5 text-left text-sm font-semibold text-dark backdrop-blur-sm backdrop-filter sm:table-cell"
    }, "Provider"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "sticky top-0 z-10 hidden border-b border-gray-300 bg-white/75 px-3 py-3.5 text-left text-sm font-semibold text-dark backdrop-blur-sm backdrop-filter lg:table-cell"
    }, "Widget Name"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "sticky top-0 z-10 border-b border-gray-300 bg-white/75 px-3 py-3.5 text-left text-sm font-semibold text-dark backdrop-blur-sm backdrop-filter"
    }, "Reference ID"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "sticky top-0 z-10 border-b border-gray-300 bg-white/75 px-3 py-3.5 text-left text-sm font-semibold text-dark backdrop-blur-sm backdrop-filter"
    }, "Status"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "sticky top-0 z-10 border-b border-gray-300 bg-white/75 px-3 py-3.5 text-left text-sm font-semibold text-dark backdrop-blur-sm backdrop-filter"
    }, "Amount"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "sticky top-0 z-10 border-b border-gray-300 bg-white/75 px-3 py-3.5 text-left text-sm font-semibold text-dark backdrop-blur-sm backdrop-filter"
    }, "Response Payload")
  ])
], -1)
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 1,
  class: "flex justify-center items-center h-full"
}
const _hoisted_9 = { class: "flex justify-center items-center flex-shrink-0 w-8 h-8 rounded-sm warning" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "pl-2 text-secondary" }, "No logs found", -1)

import WarningIcon from "../icons/WarningIcon.vue";

import { PaymentGatewayLogsI } from '@/interfaces/interfaces';


export default /*#__PURE__*/_defineComponent({
  __name: 'LogsTable',
  props: {
    logs: {}
  },
  emits: ["payload-modal:open"],
  setup(__props: any, { emit }) {

const props = __props;





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (props.logs.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("table", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.logs, (log, logIdx) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: log.identifier
                  }, [
                    _createElementVNode("td", {
                      class: _normalizeClass([logIdx !== props.logs.length - 1 ? 'border-b border-gray-200' : '', 'py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-secondary sm:pl-6 lg:pl-8'])
                    }, _toDisplayString(log.transactionTimestamp), 3),
                    _createElementVNode("td", {
                      class: _normalizeClass([logIdx !== props.logs.length - 1 ? 'border-b border-gray-200' : '', 'hidden px-3 py-4 text-sm whitespace-nowrap text-secondary sm:table-cell'])
                    }, _toDisplayString(log.provider), 3),
                    _createElementVNode("td", {
                      class: _normalizeClass([logIdx !== props.logs.length - 1 ? 'border-b border-gray-200' : '', 'hidden px-3 py-4 text-sm whitespace-nowrap text-secondary lg:table-cell'])
                    }, _toDisplayString(log.widgetName), 3),
                    _createElementVNode("td", {
                      class: _normalizeClass([logIdx !== props.logs.length - 1 ? 'border-b border-gray-200' : '', 'px-3 py-4 text-sm whitespace-nowrap text-secondary'])
                    }, _toDisplayString(log.transactionReferenceId || '-'), 3),
                    _createElementVNode("td", {
                      class: _normalizeClass([logIdx !== props.logs.length - 1 ? 'border-b border-gray-200' : '', 'px-3 py-4 text-sm whitespace-nowrap text-secondary'])
                    }, _toDisplayString(log.transactionStatus || '-'), 3),
                    _createElementVNode("td", {
                      class: _normalizeClass([logIdx !== props.logs.length - 1 ? 'border-b border-gray-200' : '', 'px-3 py-4 text-sm whitespace-nowrap text-secondary'])
                    }, _toDisplayString(log.amount || '-'), 3),
                    _createElementVNode("td", {
                      class: _normalizeClass([logIdx !== props.logs.length - 1 ? 'border-b border-gray-200' : '', 'relative py-4 pr-4 pl-3 text-sm font-medium whitespace-nowrap sm:pr-8 lg:pr-8'])
                    }, [
                      (log.responsePayload)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "text-action-primary hover:text-primary-dark cursor-pointer transition-all duration-300",
                            onClick: ($event: any) => (emit('payload-modal:open', log.responsePayload))
                          }, " View Payload ", 8, _hoisted_6))
                        : (_openBlock(), _createElementBlock("span", _hoisted_7, "-"))
                    ], 2)
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(WarningIcon)
          ]),
          _hoisted_10
        ]))
  ]))
}
}

})